export default {
    word1:
      "โบรกเกอร์ที่อยู่ภายใต้การกำกับดูแลระดับสูงสุด | EBC Financial Group",
    word2:
      "EBC Financial Group โบรกเกอร์ชั้นนำระดับโลกที่ได้รับความไว้วางใจ โดยเป็นผู้ให้บริการซื้อขายหลักทรัพย์ ฟอเร็กซ์ ดัชนี หุ้น และสินค้าโภคภัณฑ์",
    word3: "โบรกเกอร์ที่ดีที่สุด",
    word4: `EBC ได้รับความไว้วางใจจากนักลงทุนกว่า <span class="subtitle-20_medium md-body-14_medium">100+</span> ประเทศ`,
    word5: "เลเวอเรจสูงสุด",
    word6: "ผลิตภัณฑ์เทรด",
    word7: "สเปรดมาตรฐานระดับสถาบัน",
    word8:
      "EBC x มูลนิธิสหประชาชาติ เพื่อต่อสู้กับโรคมาลาเรีย",
    word9: "EBC Copy Trading เทรดตามมือโปรได้ฟรี",
    word10:
      "คัดลอกสัญญาณเทรดชั้นนำฟรี หรือสร้างรายได้ด้วยการเป็นผู้ให้สัญญาณ พร้อมรับโบนัสสูงสุด 18% ต่อปี",
    word11: "โปร่งใสและเปิดเผย",
    word12: "คัดลอกเพียงคลิกเดียว",
    word13: "รับโบนัสสูงสุด 18% ต่อปี",
    word14: "อัปเดตรายการเทรดแบบเรียลไทม์",
    word15: `EBC x มหาวิทยาลัย Oxford จัดซีรีส์สัมมนา`,
    word16: "ประโยชน์จากเศรษฐศาสตร์ภูมิอากาศ สร้างโอกาสในการลงทุนได้อย่างไร?",
    word17: "ลงทะเบียน",
    word18: "เรียนรู้เพิ่มเติม",
    word19: "เทรดตลาดการเงินทั่วโลก",
    word20:
      "ครอบคลุมผลิตภัณฑ์ชั้นนำกว่า 200+ รายการทั่วโลก พร้อมสภาพคล่องระดับสถาบันและค่าสเปรดที่แข่งขันได้ในตลาด เพื่อมอบประสบการณ์การเทรดที่เหนือกว่า",
    word21: "ฟอเร็กซ์",
    word22: "สินค้าโภคภัณฑ์",
    word23: "ดัชนี",
    word24: "หุ้นสหรัฐฯ",
    word25: "ETF",
    word26: "ผลิตภัณฑ์เทรด",
    word27: "ราคาขาย",
    word28: "ราคาซื้อ",
    word29: "สเปรด",
    word30: "เลเวอเรจ",
    word31: "ผลิตภัณฑ์อื่น ๆ ",
    word32: "87.6% ของออเดอร์คำสั่งซื้อขายได้รับราคาที่ดีกว่า",
    word33:
      "ระบบรวมสภาพคล่องของ EBC มีประสิทธิภาพเหนือกว่าระบบเทรดแบบดั้งเดิม ทั้งด้านราคา ความเร็วในการซื้อขาย และความเสถียร",
    word34: "ประมวลผลต่อวินาที",
    word35: "ความเร็วคำสั่งซื้อ",
    word36: "ความเสถียรในการส่งข้อมูล",
    word37: "สเปรดมาตรฐานระดับสถาบัน",
    word38:
      "ประสิทธิภาพการปรับคำสั่งซื้อขายของ EBC อยู่ในระดับท็อป 2.5% ของอุตสาหกรรม",
    word39: "ลงทะเบียน",
    word40: "เทรดอย่างปลอดภัย ด้วยความไว้วางใจจากทั่วโลก",
    word41: "กฎระเบียบเข้มงวดและมาตรการปกป้องครบวงจร เพื่อคุ้มครองทุกการเทรด",
    word42: "คุ้มครองอย่างครอบคลุม เพื่อความสบายใจ",
    word43:
      "EBC ให้ความสำคัญกับความปลอดภัยของเงินทุนเป็นหลัก  โดยเงินทุนของผู้ใช้จะถูกจัดเก็บในบัญชี Barclays Bank พร้อมปฏิบัติตามข้อกำหนดของหน่วยงานกำกับดูแล FCA, CIMA และ ASIC อย่างเคร่งครัด นอกจากนี้ EBC ยังเข้าร่วมโครงการคุ้มครองเงินทุนที่ได้รับการสนับสนุนจากรัฐบาลทั่วโลก และได้รับความคุ้มครองประกันธุรกิจหลายรายการจาก Lloyds of London  เพื่อสร้างระบบการรักษาความปลอดภัยอย่างครอบคลุม",
    word44: "พันธมิตรระดับโลกของ EBC",
    word45:
      "EBC ร่วมมือกับธนาคารและสถาบันระดับโลกกว่า 25 แห่ง ทำให้เรามีสภาพคล่องระดับสถาบัน พร้อมสเปรดเริ่มต้นเพียง 0.0 Pips เทียบเท่าธนาคารชั้นนำ นอกจากนี้ EBC ยังร่วมจัดสัมมนากับมหาวิทยาลัย Oxford และจับมือกับมูลนิธิสหประชาชาติ (UN Foundation) ต่อสู้โรคมาลาเรีย พร้อมเดินหน้าสานต่อความร่วมมือกับพันธมิตรทั่วโลก เพื่อรับผิดชอบต่อสังคมและส่งเสริมการพัฒนาอย่างยั่งยืน",
    word46: "ใบอนุญาตระดับสากล",
    word47: "FCA (สหราชอาณาจักร)",
    word48: "EBC FINANCIAL GROUP (UK) Ltd",
    word49: " ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority (FCA) ",
    word50: "หมายเลขควบคุม: 927552",
    word51: "CIMA (หมู่เกาะเคย์แมน)",
    word52: "EBC FINANCIAL GROUP (Cayman) Ltd",
    word53: " ได้รับอนุญาตและควบคุมโดย Cayman Islands Monetary Authorit (CIMA)",
    word54: "หมายเลขควบคุม: 2038223",
    word55: "ASIC (ออสเตรเลีย)",
    word56: "EBC FINANCIAL GROUP (Australia) Pty Ltd",
    word57:
      " ได้รับอนุญาตและควบคุมโดย Australian Securities and Investments Commission (ASIC) ",
    word58: "หมายเลขควบคุม: 500991",
    word59:
      "บริษัทในเครือของ EBC Financial Group ทุกแห่งดำเนินงานภายใต้การกำกับดูแลอย่างเข้มงวด และได้รับใบอนุญาตระดับสูงสุดตามเขตอำนาจศาลของตน",
    word60:
      "ตั้งแต่วันแรกของการก่อตั้ง เราให้ความสำคัญกับการปฏิบัติตามกฎระเบียบอย่างเคร่งครัด และวางความปลอดภัยของสินทรัพย์ลูกค้าเป็นหัวใจหลักของธุรกิจ หลักการนี้ไม่ใช่เพียงคำมั่นสัญญา แต่เป็นข้อกำหนดที่ไม่สามารถต่อรองได้",
    word61:
      "เราเลือกทำงานร่วมกับธนาคารชั้นนำ ปฏิบัติตามกรอบกำกับดูแลหลายภูมิภาคอย่างเข้มงวด และใช้มาตรการบริหารความเสี่ยงระดับมาตรฐานอุตสาหกรรม ในด้านความปลอดภัย ความโปร่งใส และความไว้วางใจจากลูกค้า เรายึดมั่นมาตรฐานสูงสุดและจะไม่ลดละในอนาคต",
    word62: "เข้าถึงได้ทั่วโลก พร้อมฝ่ายบริการลูกค้าในพื้นที่",
    word63: "ไม่ว่าคุณจะอยู่ที่ไหน เราพร้อมให้บริการการอย่างมืออาชีพ",
    word64: "ปริมาณการเทรดเฉลี่ยต่อเดือน (USD)",
    word65: "ผู้ใช้งานที่ลงทะเบียน",
    word66: "ผลตอบแทนจากการปรับคำสั่งเทรด (ไตรมาส 2 ปี 2025)",
    word67: "ประเทศที่ครอบคลุม",
    word68: "ติดต่อเรา",
    word69: "ทีมไทย",
    word70: "ข่าวสาร EBC",
    word71:
      "เข้าถึงข้อมูลล่าสุดจาก EBC ข่าวสารด้านการเงิน แนวโน้มตลาด และมุมมองจากผู้เชี่ยวชาญ",
    word72: "ข่าว",
    word73: "พันธมิตร",
    word74: "กรอกข้อมูลเพื่อติดต่อกลับ",
    word75: "ผู้จัดการบัญชีจะติดต่อกลับโดยเร็วที่สุด",
    word76: "ส่งข้อมูล",
    word77: "lots",
    word78: "pips",
    word79: "Others",
    word80: "โบรกเกอร์ยอดนิยม 10 อันดับแรก",
    word81: "โบรกเกอร์ที่โปร่งใสมากที่สุด",
    word82: "โบรกเกอร์ที่ได้รับการรีวิวดีที่สุด",
    word83: "โบรกเกอร์ที่มีการดำเนินการที่ยอดเยี่ยม",
    word84: "โบรกเกอร์ที่มีประสิทธิภาพมากที่สุด",
    word85: "โบรกเกอร์ที่เชื่อถือได้มากที่สุด",
    word86: "โบรกเกอร์ CFD ที่ดีที่สุด",
    word87: "โบรกเกอร์ ECN ที่ดีที่สุด",
    word88: "โบรกเกอร์ดาวรุ่งระดับสากล",
    word89: "ผู้ให้บริการ CFD ที่ดีที่สุด",
    word90: "แพลตฟอร์มเทรด FX ที่ดีที่สุด",
    word91: "การดำเนินการซื้อขายที่ดีที่สุด",
    word92: "โบรกเกอร์ที่ดีที่สุด",
    word93: "ชื่อ-นามสกุล",
    word94: "อีเมล",
    word95: "เบอร์โทรศัพท์",
    word96: "รหัสยืนยัน",
};
